import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Modal, FormControl, FormGroup } from 'react-bootstrap';
import { withTranslation, Translation } from 'react-i18next';

class TariffConfirmationButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmationModal: false,
    };

    this.storeChange = () => this.handleStoreChange();
  }

  componentDidMount() {
    this.props.store.addChangeListener(this.storeChange);
  }

  componentWillUnmount() {
    this.props.store.removeChangeListener(this.storeChange);
  }

  handleStoreChange() {
    if (this.props.store.getStatus() === 'success') {
      this.setState({ showConfirmationModal: false });
    }
  }

  render() {
    const {
      controlTitle,
      disabled,
      skipConfirmation,
      confirmationTitle,
      message,
      confirmTitle,
      dismissTitle,
      store,
    } = this.props;

    let control = (
      <Button bsStyle="primary" disabled={disabled}>
        {controlTitle}
      </Button>
    );

    if (this.props.controlType === 'icon') {
      control = controlTitle;
    }

    return (
      <span
        onClick={skipConfirmation ? this.handleConfirm() : this.openModal()}
      >
        {control}
        <span>
          <TariffConfirmationModal
            message={message}
            show={this.state.showConfirmationModal}
            onHide={() => this.setState({ showConfirmationModal: false })}
            confirmationTitle={confirmationTitle}
            confirmTitle={confirmTitle}
            dismissTitle={dismissTitle}
            onConfirm={this.handleConfirm()}
            store={store}
          />
        </span>
      </span>
    );
  }

  handleConfirm() {
    return (password) => {
      this.props.onConfirm(password);
    };
  }

  openModal() {
    return () => {
      this.setState({
        showConfirmationModal: !this.state.showConfirmationModal,
      });
    };
  }
}

TariffConfirmationButton.propTypes = {
  controlTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  confirmationTitle: PropTypes.string,
  message: PropTypes.string.isRequired,
  confirmTitle: PropTypes.string.isRequired,
  dismissTitle: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  skipConfirmation: PropTypes.bool,
  controlType: PropTypes.string.isRequired,
  store: PropTypes.object.isRequired,
};

class TariffConfirmationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
    };
  }

  render() {
    const confirmTitle = this.props.confirmTitle;
    const dismissTitle = this.props.dismissTitle;
    return (
      <Modal show={this.props.show} onHide={() => this.props.onHide()}>
        <Modal.Header>
          <Translation>{(t) => <h1>{t('CONFIRM_UPDATE')}</h1>}</Translation>
        </Modal.Header>

        <Modal.Body>
          <Translation>
            {(t) => (
              <>
                <p>{t('CHANGES_TO_TARIFF_MSG')}</p>
                <p>{t('PRICING_UPDATES_NIGHTLY_MSG')}</p>
              </>
            )}
          </Translation>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={this.onCancel()}>{dismissTitle}</Button>
          <Button bsStyle="primary" onClick={this.onSubmit}>
            {confirmTitle}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  onCancel() {
    return (e) => {
      e.preventDefault();
      this.props.store.reset();
      this.props.onHide();
    };
  }

  onSubmit = (e) => {
    this.props.onConfirm(this.state.password);
  }
}
export default withTranslation()(TariffConfirmationButton);
